import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import {
    GridElementPropertyValidation,
    type GridElementResource,
} from '../../../../resource/resources/artifacts/use_case/representation/gridElementResource';
import { PropertyInputs } from '../../../reusable-components/base/property-bases/PropertyInputs';
import { ReferenceInputs } from '../../../reusable-components/base/reference-text-fields/ReferenceInputs';
import type { PropertyValidationInformation } from '../../../util/PropertyValidationInformation';
import { GridElementDecoratorDisplay } from './GridElementDecoratorDisplay';

export const GridElementContent = ({
    id,
    projectId,
    projectVersionId,
    form,
    formNames,
    readOnly,
}: {
    id?: string;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
    form: UseFormReturn<GridElementResource>;
    formNames: FormNames<GridElementResource>;
    readOnly: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: GridElementPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.GRID_ELEMENT,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.xIndex}
                    control={form.control}
                    nullable={false}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementPropertyValidation.X_INDEX
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.yIndex}
                    control={form.control}
                    nullable={false}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementPropertyValidation.Y_INDEX
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.width}
                    control={form.control}
                    nullable={false}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementPropertyValidation.WIDTH
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <PropertyInputs.Integer
                    name={formNames.height}
                    control={form.control}
                    nullable={false}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementPropertyValidation.HEIGHT
                    )}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <ReferenceInputs.ProcessArea
                    name={formNames.processArea}
                    nullable={true}
                    form={form}
                    projectVersionId={projectVersionId}
                    projectId={projectId}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        GridElementPropertyValidation.PROCESS_AREA
                    )}
                />
            </Grid.Col>
            <Show when={id}>
                {(parentId) => (
                    <Grid.Col span={12}>
                        <GridElementDecoratorDisplay parentId={parentId} />
                    </Grid.Col>
                )}
            </Show>
        </Grid>
    );
};
